.close {
  position: absolute;
  top: 0.2rem;
  width: 1.6rem;
  height: 1.6rem;
  right: 0.2rem;
  opacity: 0.8;
  cursor: pointer;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 100ms ease-in-out;

  svg {
    width: 0.8rem;
    height: 0.8rem;
    fill: var(--text-color-white);
    stroke: var(--text-color-white);
  }

  &:hover {
    background-color: rgba(255, 255, 255, 25%);
  }
}

.alert-item {
  position: relative;
  border-radius: 0.6rem;
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: 0;
  line-height: 1.2rem;
  text-transform: uppercase;
  display: inline-block;

  /* The `default` branch of the original switch. Any data-type that is not one
     of the four below (including the absent attribute) lands here. */
  background-color: transparent;
  color: var(--color-error);
  border: 2px solid var(--color-error);

  padding: 0.8rem 1.6rem;
  padding-right: 1.6rem;

  &[data-small='true'] {
    padding: 0.4rem 1.6rem;
  }

  /* Must stay after [data-small]: that rule sets the `padding` shorthand, which
     resets padding-right, exactly as the original declaration order did. */
  &[data-close='true'] {
    padding-right: 2.4rem;
  }

  &[data-type='error'] {
    background-color: var(--color-error);
    color: var(--white-default);
    border: 2px solid var(--color-error);
  }

  &[data-type='success'] {
    background-color: var(--color-success);
    color: var(--white-default);
    border: 2px solid var(--color-success);
  }

  &[data-type='data'] {
    background-color: var(--color-primary);
    color: var(--white-default);
    border: 2px solid var(--color-primary);
  }

  &[data-type='warning'] {
    background-color: var(--color-warning);
    color: var(--white-default);
    border: 2px solid var(--color-warning);
  }
}
